import { generatePath, useRouteMatch } from 'react-router'

import ButtonWithTooltip from 'common/components/ButtonWithTooltip'
import {
  hideLeftPanel,
  selectLeftPanelVisibility,
  showLeftPanel,
} from 'common/components/leftPanel/store/leftPanelSlice'
import SubNavBar, { SubNavItem } from 'common/components/navigation/subNavBar'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { SidebarLeftMenu as SidebarLeftMenuIcon } from 'common/icons'

import { DASHBOARD_NAV_ITEMS, PATH } from '../interfaces'

const DashboardHeader = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const dispatch = useAppDispatch()
  const isDashboardPathMatch = useRouteMatch(PATH.Dashboard)
  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  return (
    <SubNavBar
      preTitle={
        isDashboardPathMatch && (
          <ButtonWithTooltip
            tooltip
            tooltipText={
              leftPanelVisibility === 'hidden' || leftPanelVisibility === 'auto'
                ? 'Show panel'
                : 'Hide panel'
            }
            prefixIcon={<SidebarLeftMenuIcon isDefaultColor={false} size={5} />}
            onClick={() => {
              leftPanelVisibility === 'hidden'
                ? dispatch(showLeftPanel())
                : dispatch(hideLeftPanel())
            }}
          />
        )
      }
      title={isDashboardPathMatch && <span>Reports</span>}
    >
      {DASHBOARD_NAV_ITEMS.map(({ key, title, path }) => (
        <SubNavItem
          key={key}
          title={title}
          to={generatePath(path, { accountId })}
        />
      ))}
    </SubNavBar>
  )
}

export default DashboardHeader
